import { render, staticRenderFns } from "./bonusAdmin.vue?vue&type=template&id=02ec2622&scoped=true"
import script from "./bonusAdmin.vue?vue&type=script&lang=js"
export * from "./bonusAdmin.vue?vue&type=script&lang=js"
import style0 from "./bonusAdmin.vue?vue&type=style&index=0&id=02ec2622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec2622",
  null
  
)

export default component.exports